import * as type from '../actions/types';

const initialState = {
  forecasterEnabled: null, // null means not loaded yet, true/false after API response
  analyticsEnabled: null,
  forecastLoading: true,
  analyticsLoading: true,
  error: null,
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case type.FETCH_FORECASTER_ENABLED_PENDING:
      return {
        ...state,
        forecastLoading: true,
        analyticsLoading: true,
        error: null,
      };

    case type.FETCH_FORECASTER_ENABLED_SUCCESS:
      return {
        ...state,
        forecasterEnabled: Boolean(action.payload),
        forecastLoading: false,
        error: null,
      };

    case type.FETCH_ANALYTICS_ENABLED_SUCCESS:
      return {
        ...state,
        analyticsEnabled: Boolean(action.payload),
        analyticsLoading: false,
      };

    case type.FETCH_FORECASTER_ENABLED_FAILURE:
      return {
        ...state,
        forecasterEnabled: false,
        analyticsEnabled: state.analyticsEnabled ?? false,
        forecastLoading: false,
        analyticsLoading: false,
        error: action.payload,
      };

    case type.SET_ACTIVE_RESTAURANT:
    case type.SET_LOGOUT:
      return initialState;

    default:
      return state;
  }
};
